export default "__VITE_ASSET__BZViLSYT__"